import React from "react"
import { Link } from "react-router-dom"
import type { LucideIcon } from "lucide-react"
import { useGuardLinkClick } from "./unsavedChangesGate"
import "./StudentNavItem.style.scss"

export type StudentNavItemVariant = "sidebar" | "bottom"

interface StudentNavItemProps {
  name: string
  shortName: string
  path: string
  icon: LucideIcon
  active: boolean
  collapsed?: boolean
  variant?: StudentNavItemVariant
}

const StudentNavItem = ({
  name,
  shortName,
  path,
  icon: Icon,
  active,
  collapsed = false,
  variant = "sidebar",
}: StudentNavItemProps) => {
  const onClick = useGuardLinkClick(path)

  if (variant === "bottom") {
    return (
      <Link
        to={path}
        className={`student-nav-item student-nav-item--bottom ${
          active ? "is-active" : ""
        }`}
        onClick={onClick}
      >
        <div className="student-nav-item__icon-wrap">
          <Icon className="student-nav-item__icon" />
        </div>
        <span className="student-nav-item__short">{shortName}</span>
      </Link>
    )
  }

  return (
    <Link
      to={path}
      title={collapsed ? name : undefined}
      className={`student-nav-item student-nav-item--sidebar ${
        active ? "is-active" : ""
      } ${collapsed ? "is-collapsed" : ""}`}
      onClick={onClick}
    >
      <Icon className="student-nav-item__icon" />
      {!collapsed && <span className="student-nav-item__label">{name}</span>}
    </Link>
  )
}

export default StudentNavItem
